/* global gtag */

export const isStoreeelGaConsoleEnabled = (() => {
  let cachedSearch = null;
  let cachedEnabled = false;

  return () => {
    try {
      if (typeof window === 'undefined') return false;
      const search = window.location?.search ?? '';
      if (search === cachedSearch) return cachedEnabled;

      cachedSearch = search;
      const params = new URLSearchParams(search);
      // 正: storeeel_console / 互換: storeeel_cosole（typo）
      const raw = params.get('storeeel_console') ?? params.get('storeeel_cosole');
      const value = String(raw ?? '').trim().toLowerCase();
      cachedEnabled = value === 'true' || value === '1';
      return cachedEnabled;
    } catch {
      return false;
    }
  };
})();

export const isStoreeelPreviewMode = (() => {
  let cachedSearch = null;
  let cachedEnabled = false;

  return () => {
    try {
      if (typeof window === 'undefined') return false;
      const search = window.location?.search ?? '';
      if (search === cachedSearch) return cachedEnabled;

      cachedSearch = search;
      const params = new URLSearchParams(search);
      cachedEnabled = params.has('_storeeel_preview_campaign_id');
      return cachedEnabled;
    } catch {
      return false;
    }
  };
})();

export const trackStoreeelEvent = (eventName, params = {}) => {
  if (isStoreeelPreviewMode()) return;
  if (typeof gtag !== 'function') return;
  if (window.storeeelGtag === undefined) return;

  const defaultParams = {
    send_to: window.storeeelGtag,
  };

  const payload = {
    ...defaultParams,
    ...params
  };

  // バックドア: URL に storeeel_console=true を付けた場合、GA4送信値を console.log に出す
  if (isStoreeelGaConsoleEnabled()) {
    console.log('[StoreeelLibrary][GA4]', eventName, payload);
  }

  gtag('event', eventName, payload);
}
